import type { Environment } from './environment';

export const environment: Environment = {
  production: false,
  proxy: false,
  mixpanelToken: 'ec1f0aa55be261bfdd4532f606dcc86c',
  REACT_APP_URL: 'https://dashboard-dev-cyan.reveliolabs.com',
  REACT_APP_API:
    'https://dashboard-dev.gp0.k8s.dc1.rlc.cloud.reveliolabs.com/proxy',
  ACCOUNT_PORTAL_ROOT: 'https://account-dev.reveliolabs.com',
  WILSON_ACCOUNT_PORTAL_ROOT: 'https://account-dev.reveliolabs.com',
  ACCOUNT_PORTAL_BACKEND_ROOT:
    'https://account-portal-dev.gp0.k8s.dc1.rlc.cloud.reveliolabs.com',
  DASH_META_API: 'https://dash-meta-dev.gp0.k8s.dc1.rlc.cloud.reveliolabs.com',
  GO_API_ROOT: 'https://dashboard-dev.gp0.k8s.dc1.rlc.cloud.reveliolabs.com',
  ORY_KRATOS_URL: 'https://kratos-dev.gp0.k8s.dc1.rlc.cloud.reveliolabs.com',
  COMPANY_MAPPER_URL:
    'https://dev-comp-map.gp0.k8s.dc1.rlc.cloud.reveliolabs.com',
  COMPANY_MAPPER_SNOWFLAKE_URL:
    'https://dev-comp-map-sfw.gp0.k8s.dc1.rlc.cloud.reveliolabs.com',
  OPEN_REPLAY_PROJECT_KEY: 'pIcq54mQEQBu5QlixVFh',
  DOWNLOAD_DELIVERY_FILE_PREFIX: 'dev',
  UNLEASH_CLIENT_KEY:
    '*:development.2a8219f0ce918268f3c56ab1305d44e48dbfd06091910ef34f2c1fcc',
  UNLEASH_URL: 'https://us.app.unleash-hosted.com/usdd0003/api/frontend',
  RUPT_CLIENT_ID: '52a02c58-a84f-4627-ac07-f03415754e6b',
  SLOTS_API_KEY: 'iwveaelahjbtmvaokizrseemcwnoualx',
  ZOHO_SALES_IQ_WIDGET_CODE:
    'siq05ac96fd9a1d70fc6dd2f68e4e1011cd3bffeacb36747bb35f1aba29d4768893',
  FIREBASE_API_KEY: 'AIzaSyCqdVdpeJtryf89dkwPKu0Fb7MfS9qlXY8',
  FIREBASE_AUTH_DOMAIN: 'dashboard-ui-revelio.firebaseapp.com',
  FIREBASE_PROJECT_ID: 'dashboard-ui-revelio',
  FIREBASE_STORAGE_BUCKET: 'dashboard-ui-revelio.appspot.com',
  FIREBASE_MESSAGING_SENDER_ID: '240755017346',
  FIREBASE_APP_ID: '1:240755017346:web:3b604dbc7ee9eb2ec4d69b',
  FIREBASE_MEASUREMENT_ID: 'G-TK5FZE2RPZ',
};
